import React, { Component } from "react";
import { Service } from "../../../service/service";
import { API } from "../../../../const";
import _ from "lodash";
import { switchFonction } from "../../../../ReactConst";

function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function toUpperCaseFirst(string) {
  if (!_.isEmpty(string)) {
    string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.substring(1);
  }
}

export default class StaffCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kidURI: "",
    };
  }

  componentWillMount() {
    let tok = localStorage.getItem("token");
    var kidsId = this.props.staff.id;
    const response = Service.get(`${API}api/creche/agents/${kidsId}`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      this.setState({
        kidURI: res.data.urlPhoto,
      });
    });
    response.catch((err) => {});
  }

  render() {
    const { staff, handleCheck, index } = this.props;
    return (
      <li className="col-md-6 px-2">
        <input
          key={index}
          type="checkbox"
          id={"staff." + index}
          onChange={(e) => {
            e.preventDefault();
            handleCheck(staff, index);
          }}
          checked={staff.present}
        />
        {/* <input type="checkbox" /> */}
        <label className="rounded15 box-shadow" htmlFor={"staff." + index}>
          <span
            className="avatar"
            style={{
              color: "white",
              backgroundImage:
                this.state.kidURI !== ""
                  ? "url(" + this.state.kidURI + ")"
                  : "",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
              position: "relative",
              width: "65px",
              minHeight: "55px",
            }}
          />
          {staff.nom === undefined ? (
            <span className="name" style={{ textAlign: "left" }}>Compte supprimé</span>
          ) : (
            <span className="name" style={{ textAlign: "left" }}>
              {toUpperCaseFirst(staff.prenom) +
                " " +
                jsUpperCaseFirst(staff.nom) +
                ". "}
              <small>{"(" + switchFonction(staff.fonctionAgent) + ")"}</small>
            </span>
          )}
        </label>
      </li>
    );
  }
}
